import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import thunk from "redux-thunk";
import userReducer from "./reducers/userReducer";
import appReducer from "./reducers/appReducer";
import workerReducer from "./reducers/workerReducer";
import remoteReducer from "./reducers/remoteReducer";
import translationReducer from "./reducers/translationReducer";
import addEditReducer from "./reducers/addEditWorker";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["remote","translation"],
};

const rootReducer = combineReducers({
  user: userReducer,
  appConfig: appReducer,
  workers: workerReducer,
  remote: remoteReducer,
  translation:translationReducer,
  addEditWorker: addEditReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Array of all middlewares to be applied.
const middlewares = [thunk];

// devtools for debugging in dev environment.
const devTools =
  // eslint-disable-next-line no-undef
  process.env.REACT_APP_DROP_CONSOLE !== "true" &&
  window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__ &&
      window.__REDUX_DEVTOOLS_EXTENSION__()
    : (a) => a;
const store = createStore(
  persistedReducer,
  compose(applyMiddleware(...middlewares), devTools)
);

let persistor = persistStore(store);
export { persistor };
export default store;
